module.exports = __webpack_public_path__ + "static/media/p_10_2.03fdbf53.png";